import React from 'react';
import { AiFillExclamationCircle } from 'react-icons/ai';
import { ErrorMessageProps } from '@typing/props';

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
    if (!message) return null;

    return (
        <div className="text-red bg-light_red font-medium text-sm my-4 py-2 mx-auto flex items-center justify-center rounded px-3">
            <AiFillExclamationCircle className="text-xl mr-3" />
            {message}
        </div>
    );
};

export default ErrorMessage;
